
import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Assignment, Close, FileCopySharp, Visibility } from '@material-ui/icons';
import { onlyInteger } from 'hooks/Pipe';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import Button from 'components/CustomButtons/Button.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { Link, useParams } from 'react-router-dom';
import Badge from 'components/Badge/Badge';

//servicios
import { wsGet, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import { currency } from 'hooks/Pipe';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 80 },
  { Header: 'Tipo', accessor: 'ReceiptType' },
  { Header: 'Serie', accessor: 'ReceiptSerie'},
  { Header: 'Numero', accessor: 'ReceiptNumber'},
  { Header: 'Total Documento', accessor: 'DocTotal'},
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const classes = useStyles();
  const [dataLoading, setDataLoading] = useState(false);

  const { id, showNotify, oCDocumento, setOCDocumento, oCDetails, reload, ordenCompra } = props;

  return (
    <>
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado de documentos para orden de compra
          <span style={{ fontSize: '14px' }}>
            <b>{` (${ordenCompra.CardName || ''})`}</b>
          </span>
          {dataLoading && <LoadingSpinner />}
          </h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            exportExcel={false}
            formatDate="DD-MM-YYYY"
            columns={columns}
            data={oCDocumento.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <Button justIcon round simple color="primary">
                      <Link to={`/admin/compras/operaciones/importaciones/${item.purch_purchase_id}`}>
                        <Visibility />
                      </Link>
                    </Button>
                  </div>
                ),
                ReceiptType: item.ReceiptType,
                ReceiptSerie: item.ReceiptSerie,
                ReceiptNumber: item.ReceiptNumber,
                DocTotal: currency(item.DocTotal),
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
